import StepBaseService from "../stepBase";
import StepBusinessType from "../stepBase/stepBusinessType";

class CreateSupportingFileStepService extends StepBaseService {
  // @ts-ignore
  getSupportingFileStepKey = () => {
    return {
      dataKey: StepBusinessType.supportingFile.dataKey,
      settingKey: "getCreateSupportingFileStepItem",
    };
  };

  // @ts-ignore
  getTaskInfoKey = () => {
    return StepBusinessType.taskInfo;
  };

  // @ts-ignore
  getFlowStepData = () => null;
}

export default new CreateSupportingFileStepService();
